<template>
  <div class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-40 w-full h-full flex justify-center items-center bg-black bg-opacity-60 px-4 sm:px-6" @click.self="closeModal">
    <div
      :class="
        size === 1
          ? 'max-w-xs'
          : size === 2
          ? 'max-w-sm'
          : size === 3
          ? 'max-w-md'
          : size === 4
          ? 'max-w-lg'
          : size === 5
          ? 'max-w-xl'
          : size === 6
          ? 'max-w-2xl'
          : size === 7
          ? 'max-w-3xl'
          : size === 8
          ? 'max-w-4xl'
          : 'max-w-5xl'
      "
      class="pt-10 pb-8 px-10 w-full h-auto mx-auto bg-white rounded-3xl relative text-center"
    >
      <button v-show="close" class="absolute top-6 right-6" @click="closeModal">
        <img class="h-6" src="/icons/gray/close.svg" alt="" />
      </button>
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script setup lang="ts">
  const props = defineProps({
    size: {
      type: Number,
      required: false,
      default: 5
    },
    close: {
      type: Boolean,
      required: false,
      default: true
    }
  })
  const emit = defineEmits(['close'])

  function closeModal() {
    if (props.close) {
      emit('close')
    }
  }
</script>
